import React from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const EditWithdrawal = () => {
  return (
    <>
      <DynamicScrollToTop />
      <LayoutDashboard>
        <section className="ml-4 w-2/4">
          <div className="md-flex">
            <div className="bg-white">
              <div className="mb-12">
                <div className="flex flex-col rounded-md w-full py-6 px-8 bg-white shadow-lg justify-start h-full">
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                      Nama Bank :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                      <option>Pilih area</option>
                      <option>BCA</option>
                      <option>Mandiri</option>
                      <option>BRI</option>
                      <option>BNI</option>
                      <option>LinkAja</option>
                      <option>OVO</option>
                      <option>DANA</option>
                    </select>
                  </label>
                  <label className="flex items-center mt-6">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                        Nomor Rekening :{" "}
                    </span>
                    <input
                      class="form-input mt-1 w-2/4"
                      placeholder="Masukkan nomor rekening"
                      defaultValue="123456"
                    />
                  </label>
                  <label className="flex items-center mt-6">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                        Atas Nama :{" "}
                    </span>
                    <input
                      class="form-input mt-1 w-2/4"
                      placeholder="Masukkan atas nama"
                      defaultValue="Stephanie"
                    />
                  </label>
                  <label className="flex items-center mt-4 ml-16">
                    <button className="bg-green-100 text-white font-bold py-3 px-4 rounded mt-2 flex">
                      <Link to="/account">
                      Simpan
                      </Link>
                    </button>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </section>
        
      </LayoutDashboard>
    </>
  );
};
export default EditWithdrawal;
